import { formatBytes, formatNumber } from "@prismicio/editor-support/String"

export type Unit = "gigabyte" | undefined

interface FormatValueOptions {
  unit?: Unit
  notation?: "compact" | "standard"
}

export function formatValue(value: number, options: FormatValueOptions = {}) {
  const { unit, notation = "compact" } = options
  if (unit === "gigabyte") {
    return formatGigabytes(value, { notation })
  }
  return formatNumber(value, { notation })
}

function formatGigabytes(
  gigabytes: number,
  options: Pick<FormatValueOptions, "notation"> = {},
): string {
  const { notation = "compact" } = options
  return formatBytes(gigabytes * Math.pow(1_000, 3), {
    base: "decimal",
    maximumFractionDigits: notation === "compact" ? 2 : 4,
    minimumFractionDigits: 0,
    minimumUnit: "GB",
  })
}
